import React, { CSSProperties, useEffect } from 'react'
import { CSSTransition } from 'react-transition-group'
import DynamicSVG from '../../DynamicSVG/DynamicSVG'

type Props = {
  id:number
  title: string,
  description: string,
  animationDelay: number,
  deleteCallback: ((id: number) => void),
  startAnimation:boolean
}

function Toast({ title, description,animationDelay,startAnimation,id,deleteCallback}: Props) {
  
  const CSScustomProps = {
    "--Delay": `${animationDelay}ms`,
  }
  function deleteToast() {
    deleteCallback(id)
  }
  return (
    
      <li className='Toast' style={CSScustomProps as CSSProperties}>
      <DynamicSVG className='Toast-Icon' SvgName="CheckMark-Icon"/>
      <span className='Toast-Title'>{title}</span>
      <span className='Toast-Description'>{description}</span>
      <button className='Toast-CloseBtn' onClick={deleteToast}>X</button>
      </li>
    
  )
}

export default Toast